export let prevData = [
  {
    id: "bitcoin",
    symbol: "btc",
    name: "Bitcoin",
    image:
      "https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1696501400",
    current_price: 5775868,
    market_cap: 113636204535668,
    market_cap_rank: 1,
    fully_diluted_valuation: 121286149365434,
    total_volume: 1649682625152,
    high_24h: 5806729,
    low_24h: 5631868,
    price_change_24h: 130006,
    price_change_percentage_24h: 2.30267,
    market_cap_change_24h: 2789908479841,
    market_cap_change_percentage_24h: 2.51692,
    circulating_supply: 19675456,
    total_supply: 21000000,
    max_supply: 21000000,
    ath: 6110932,
    ath_change_percentage: -5.48855,
    ath_date: "2024-03-14T07:10:36.635Z",
    atl: 3993.42,
    atl_change_percentage: 144526.20848,
    atl_date: "2013-07-05T00:00:00.000Z",
    roi: null,
    last_updated: "2024-04-07T05:05:25.151Z",
  },
  {
    id: "ethereum",
    symbol: "eth",
    name: "Ethereum",
    image:
      "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1696501628",
    current_price: 282246,
    market_cap: 33892924425545,
    market_cap_rank: 2,
    fully_diluted_valuation: 33892924425545,
    total_volume: 756179868312,
    high_24h: 283764,
    low_24h: 276605,
    price_change_24h: 4720.88,
    price_change_percentage_24h: 1.70107,
    market_cap_change_24h: 662984515481,
    market_cap_change_percentage_24h: 1.99514,
    circulating_supply: 120069586.459592,
    total_supply: 120069586.459592,
    max_supply: null,
    ath: 362338,
    ath_change_percentage: -22.11306,
    ath_date: "2021-11-10T14:24:19.604Z",
    atl: 28.13,
    atl_change_percentage: 1003106.14929,
    atl_date: "2015-10-20T00:00:00.000Z",
    roi: {
      times: 64.32799308111608,
      currency: "btc",
      percentage: 6432.799308111608,
    },
    last_updated: "2024-04-07T05:05:38.181Z",
  },
  {
    id: "tether",
    symbol: "usdt",
    name: "Tether",
    image:
      "https://assets.coingecko.com/coins/images/325/large/Tether.png?1696501661",
    current_price: 83.35,
    market_cap: 8904250905657,
    market_cap_rank: 3,
    fully_diluted_valuation: 8904250905657,
    total_volume: 3025622353246,
    high_24h: 83.85,
    low_24h: 83.1,
    price_change_24h: -0.1056619995413115,
    price_change_percentage_24h: -0.1266,
    market_cap_change_24h: 1102597804,
    market_cap_change_percentage_24h: 0.01238,
    circulating_supply: 106814507935.074,
    total_supply: 106814507935.074,
    max_supply: null,
    ath: 91.22,
    ath_change_percentage: -8.61535,
    ath_date: "2018-07-24T00:00:00.000Z",
    atl: 36.86,
    atl_change_percentage: 126.16155,
    atl_date: "2015-03-02T00:00:00.000Z",
    roi: null,
    last_updated: "2024-04-07T05:06:06.181Z",
  },
  {
    id: "binancecoin",
    symbol: "bnb",
    name: "BNB",
    image:
      "https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png?1696501970",
    current_price: 48977,
    market_cap: 7535688270006,
    market_cap_rank: 4,
    fully_diluted_valuation: 7535688270006,
    total_volume: 59123674084,
    high_24h: 49293,
    low_24h: 48311,
    price_change_24h: 397.66,
    price_change_percentage_24h: 0.81858,
    market_cap_change_24h: 65788969371,
    market_cap_change_percentage_24h: 0.88072,
    circulating_supply: 153856150,
    total_supply: 153856150,
    max_supply: 200000000,
    ath: 52934,
    ath_change_percentage: -7.47134,
    ath_date: "2024-03-16T00:10:54.176Z",
    atl: 2.58,
    atl_change_percentage: 1894825.82752,
    atl_date: "2017-10-19T00:00:00.000Z",
    roi: null,
    last_updated: "2024-04-07T05:05:22.455Z",
  },
  {
    id: "solana",
    symbol: "sol",
    name: "Solana",
    image:
      "https://assets.coingecko.com/coins/images/4128/large/solana.png?1696504756",
    current_price: 15051.21,
    market_cap: 6703853017699,
    market_cap_rank: 5,
    fully_diluted_valuation: 8625993336610,
    total_volume: 293488236980,
    high_24h: 15216.58,
    low_24h: 14503.28,
    price_change_24h: 396.68,
    price_change_percentage_24h: 2.70686,
    market_cap_change_24h: 210968412316,
    market_cap_change_percentage_24h: 3.24922,
    circulating_supply: 445585295.415423,
    total_supply: 573344281.116788,
    max_supply: null,
    ath: 19286.66,
    ath_change_percentage: -21.98499,
    ath_date: "2021-11-06T21:54:35.825Z",
    atl: 38.03,
    atl_change_percentage: 39469.2581,
    atl_date: "2020-05-11T19:35:23.449Z",
    roi: null,
    last_updated: "2024-04-07T05:05:31.314Z",
  },
  {
    id: "usd-coin",
    symbol: "usdc",
    name: "USDC",
    image:
      "https://assets.coingecko.com/coins/images/6319/large/usdc.png?1696506694",
    current_price: 83.31,
    market_cap: 2744703206143,
    market_cap_rank: 6,
    fully_diluted_valuation: 2745654072308,
    total_volume: 485249940562,
    high_24h: 83.65,
    low_24h: 83.09,
    price_change_24h: -0.17190643240795112,
    price_change_percentage_24h: -0.20591,
    market_cap_change_24h: 1708372344,
    market_cap_change_percentage_24h: 0.06228,
    circulating_supply: 32937416800.7223,
    total_supply: 32948827533.6383,
    max_supply: null,
    ath: 87.19,
    ath_change_percentage: -4.4247,
    ath_date: "2020-03-13T02:35:16.858Z",
    atl: 65.31,
    atl_change_percentage: 27.59826,
    atl_date: "2021-05-19T13:14:05.611Z",
    roi: null,
    last_updated: "2024-04-07T05:05:26.800Z",
  },
  {
    id: "ripple",
    symbol: "xrp",
    name: "XRP",
    image:
      "https://assets.coingecko.com/coins/images/44/large/xrp-symbol-white-128.png?1696501442",
    current_price: 49.61,
    market_cap: 2731002230849,
    market_cap_rank: 7,
    fully_diluted_valuation: 4960199614224,
    total_volume: 70358781561,
    high_24h: 49.82,
    low_24h: 48.92,
    price_change_24h: 0.330262,
    price_change_percentage_24h: 0.6702,
    market_cap_change_24h: 19069415692,
    market_cap_change_percentage_24h: 0.70317,
    circulating_supply: 55051549471,
    total_supply: 99987715632,
    max_supply: 100000000000,
    ath: 215.1,
    ath_change_percentage: -76.93766,
    ath_date: "2018-01-07T00:00:00.000Z",
    atl: 0.159343,
    atl_change_percentage: 31032.92354,
    atl_date: "2013-08-16T00:00:00.000Z",
    roi: null,
    last_updated: "2024-04-07T05:05:55.514Z",
  },
  {
    id: "staked-ether",
    symbol: "steth",
    name: "Lido Staked Ether",
    image:
      "https://assets.coingecko.com/coins/images/13442/large/steth_logo.png?1696513206",
    current_price: 282014,
    market_cap: 2686923835919,
    market_cap_rank: 8,
    fully_diluted_valuation: 2686923835919,
    total_volume: 6455117536,
    high_24h: 283019,
    low_24h: 276229,
    price_change_24h: 4376.61,
    price_change_percentage_24h: 1.57638,
    market_cap_change_24h: 37022055547,
    market_cap_change_percentage_24h: 1.39711,
    circulating_supply: 9533094.90407122,
    total_supply: 9533094.90407122,
    max_supply: null,
    ath: 358528,
    ath_change_percentage: -21.38539,
    ath_date: "2021-11-10T14:40:47.256Z",
    atl: 35697,
    atl_change_percentage: 689.578,
    atl_date: "2020-12-22T04:08:21.854Z",
    roi: null,
    last_updated: "2024-04-07T05:06:09.927Z",
  },
  {
    id: "dogecoin",
    symbol: "doge",
    name: "Dogecoin",
    image:
      "https://assets.coingecko.com/coins/images/5/large/dogecoin.png?1696501409",
    current_price: 16.44,
    market_cap: 2362772674801,
    market_cap_rank: 9,
    fully_diluted_valuation: 2363260672019,
    total_volume: 190380128428,
    high_24h: 16.46,
    low_24h: 15.02,
    price_change_24h: 1.35,
    price_change_percentage_24h: 8.95903,
    market_cap_change_24h: 201737788074,
    market_cap_change_percentage_24h: 9.33524,
    circulating_supply: 143752296383.705,
    total_supply: 143781986383.705,
    max_supply: null,
    ath: 53.62,
    ath_change_percentage: -69.34518,
    ath_date: "2021-05-08T05:08:23.458Z",
    atl: 0.00552883,
    atl_change_percentage: 297185.43754,
    atl_date: "2015-05-06T00:00:00.000Z",
    roi: null,
    last_updated: "2024-04-07T05:06:15.693Z",
  },
  {
    id: "cardano",
    symbol: "ada",
    name: "Cardano",
    image:
      "https://assets.coingecko.com/coins/images/975/large/cardano.png?1696502090",
    current_price: 49.1,
    market_cap: 1731218955465,
    market_cap_rank: 10,
    fully_diluted_valuation: 2208549949501,
    total_volume: 20428911008,
    high_24h: 49.15,
    low_24h: 48.1,
    price_change_24h: 0.717746,
    price_change_percentage_24h: 1.48336,
    market_cap_change_24h: 25901616023,
    market_cap_change_percentage_24h: 1.51887,
    circulating_supply: 35274209222.0096,
    total_supply: 45000000000,
    max_supply: 45000000000,
    ath: 225.26,
    ath_change_percentage: -78.21245,
    ath_date: "2021-09-02T06:00:10.474Z",
    atl: 1.38,
    atl_change_percentage: 3468.31058,
    atl_date: "2017-11-02T00:00:00.000Z",
    roi: null,
    last_updated: "2024-04-07T05:06:15.322Z",
  },
  {
    id: "the-open-network",
    symbol: "ton",
    name: "Toncoin",
    image:
      "https://assets.coingecko.com/coins/images/17980/large/ton_symbol.png?1696517498",
    current_price: 452.79,
    market_cap: 1569368522270,
    market_cap_rank: 11,
    fully_diluted_valuation: 2308434365580,
    total_volume: 14258254389,
    high_24h: 463.56,
    low_24h: 443.92,
    price_change_24h: 6.43,
    price_change_percentage_24h: 1.44109,
    market_cap_change_24h: 21508961837,
    market_cap_change_percentage_24h: 1.38959,
    circulating_supply: 3470609332.92967,
    total_supply: 5105030297.18658,
    max_supply: null,
    ath: 474.2,
    ath_change_percentage: -4.62428,
    ath_date: "2024-03-25T14:26:09.974Z",
    atl: 38.25,
    atl_change_percentage: 1082.25989,
    atl_date: "2021-09-21T00:33:11.092Z",
    roi: null,
    last_updated: "2024-04-07T05:05:52.897Z",
  },
  {
    id: "avalanche-2",
    symbol: "avax",
    name: "Avalanche",
    image:
      "https://assets.coingecko.com/coins/images/12559/large/Avalanche_Circle_RedWhite_Trans.png?1696512369",
    current_price: 4066.53,
    market_cap: 1536764503792,
    market_cap_rank: 12,
    fully_diluted_valuation: 1775441519987,
    total_volume: 47277559750,
    high_24h: 4088.07,
    low_24h: 3873.11,
    price_change_24h: 193.41,
    price_change_percentage_24h: 4.99374,
    market_cap_change_24h: 74391515607,
    market_cap_change_percentage_24h: 5.08704,
    circulating_supply: 377882988.259718,
    total_supply: 436572516.737248,
    max_supply: 720000000,
    ath: 10772.35,
    ath_change_percentage: -62.24877,
    ath_date: "2021-11-21T14:18:56.538Z",
    atl: 204.63,
    atl_change_percentage: 1887.34547,
    atl_date: "2020-12-31T13:15:21.540Z",
    roi: null,
    last_updated: "2024-04-07T05:05:47.864Z",
  },
];
